/**
 * Returns the name of the day in a week by its integer
 *
 * @param  {object} timetable:    The ISO day of the week
 *
 * @return {string} Returns the string of the requested ay
 */
export const timetableConditions = (timetable) => {
  const conditions = [];

  Object.keys(timetable.conditions).forEach((day) => {
    conditions[day] = [];
    const ranges = [];
    let previous = 0;
    timetable.conditions[day].forEach((condition, index) => {
      if (condition != 0) {
        if (ranges.length === 0) {
          // enter first time
          const range = {
            condition: condition,
            start: index,
            end: ++index,
          };
          ranges.push(range);
        } else if (previous === condition) {
          // enter if exists and range
          ranges[ranges.length - 1].end = ++index;
        } else {
          // enter if not exists
          const range = {
            condition: condition,
            start: index,
            end: ++index,
          };
          ranges.push(range);
        }
        previous = condition;
      } else {
        // Reset to 0
        previous = 0;
      }
    });

    // create GoToIfTime from ranges
    ranges.forEach((range) => {
      const start = convertDecimalToTime(range.start / 4);
      const end = convertDecimalToTime(range.end / 4);

      const rule = timetable.rules.find((rule) => rule.id === range.condition);

      const cond = {
        rstart: range.start / 4,
        duration: (range.end - range.start) / 4,
        start: start,
        end: end,
        day: day,
        rule: rule,
      };

      conditions[day].push(cond);
    });
  });

  return conditions;
};

/**
 * Convert decimals to hours
 *
 * @param  {number}  decimal
 *
 * @return {string}  time string
 */
export const convertDecimalToTime = (decimal) => {
  const hour = Math.floor(Math.abs(decimal));
  const minutes = Math.floor((Math.abs(decimal) * 60) % 60);
  return hour + ":" + (minutes < 10 ? "0" : "") + minutes;
};

/**
 * Returns the name of the day in a week by its integer
 *
 * @return {array} Returns an array of dates
 */
export const getDays = () => {
  return ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
};
